import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function SignUpText() {
    const { t } = useTranslation('signIn');
    return (
        <Container align='center'
            fullWidth
            spacing={12}>
            <Row spacing={56} fullWidth>
                <Line />
                <Text size='lg'>{t('or')}</Text>
                <Line />
            </Row>
            <Link activityName='SignUpActivity'
                activityParams={{}}>
                <Text size='lg' fontWeight='bold'>
                    {t('signUp')}
                </Text>
            </Link>
        </Container>
    );
}

const Container = styled(Column)`
    padding-top: 12px;
`;

const Line = styled.div`
    background-color: var(--color-gray9);
    flex: 1;
    height: 1px;
    width: 100%;
`;

export default SignUpText;
